import {useFlags} from 'launchdarkly-react-client-sdk';
import React from 'react';
import translate from '@/utils/translate';
import {ROUTES} from '@/config/routesConstants';
import BaseAuth from '@/views/auth/BaseAuth';
import ContentLabMedia from '../ContentLabMedia';

export default function ContentLabLogin() {
  const {googleAuthentication, appleAuthentication, facebookAuthentication} =
    useFlags();

  const title = translate('Welcome to Ltx Scaler');

  return (
    <BaseAuth
      mode="login"
      product="content-lab"
      title={title}
      redirectTo={ROUTES.CONTENT_LAB}
      onlyEmail
      emailLabelKey="email"
      oauthOptions={{
        google: !!googleAuthentication,
        apple: !!appleAuthentication,
        facebook: !!facebookAuthentication,
      }}
      requireTermsAgreement={false}
      mediaComponent={<ContentLabMedia />}
      signupLinkText={translate("Don't have an account?")}
      signupLinkButton={translate('Sign up')}
      submitButtonTextKey="Login with email"
    />
  );
}
